<template>
  <main>
    <div id="manage-users-form">
      <template>
        <div>
          <h2 class="mb-1">2FA Options</h2>
          <p>
            Select which part of the dashboard will be protected by password or
            OTP (One Time Password) code.
          </p>
          <br />
          <vs-row v-if="this.entityAdmin2FATypeGetter === mfaType.EMAIL">
            <vs-button @click="registerAuthenticatorPrompt">
              Setup 2FA Authenticator
            </vs-button>
          </vs-row>
          <vs-row v-else>
            <p>
              2FA via Authenticator is now
              <span style="color:green;font-weight: 600;"> enabled</span>.
            </p>
          </vs-row>

          <div v-if="merchantsList.length > 1">
            <vs-row class="mt-5 mb-6" v-if="selectedMerchant">
              <vs-col
                vs-justify="left"
                vs-align="center"
                vs-w="5"
                vs-lg="4"
                vs-sm="5"
                vs-xs="12"
              >
                <label for="withdrawal-account">Select a merchant </label>
                <select
                  id="withdrawal-account"
                  class="account-selection w-full style-select"
                  data-class="{'select-icon-validate-danger' : validateMerchantSelectionError}"
                  v-model="selectedMerchant"
                  @change="onChangeMerchant(selectedMerchant)"
                >
                  <optgroup label="Merchant List">
                    <option
                      v-for="(item, index) in merchantsList"
                      :value="item"
                      :key="index"
                    >
                      {{ item.merchant_name }}
                    </option>
                  </optgroup>
                </select>
              </vs-col>
            </vs-row>
          </div>
          <div v-if="display2FASettings">
            <div v-if="twoFactorAuthSettings">
              <vs-row
                vs-w="12"
                class="mt-5"
                v-for="(item, idx) of Object.entries(twoFactorAuthSettings)"
                :key="idx"
              >
                <vs-col
                  vs-type="flex"
                  vs-justify="left"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  vs-xs="12"
                  class="mb-1"
                >
                  <!--Dashboard Login-->
                  <vs-row v-if="item[0] === 'dashboard_login'">
                    <vs-checkbox v-model="dashboardLoginCheckbox"></vs-checkbox>
                    <p>Login to Dashboard - (OTP)</p>
                  </vs-row>
                  <!--Profile Details-->
                  <vs-row v-if="item[0] === 'update_profile_details'">
                    <vs-checkbox
                      v-model="updateProfileDetailsCheckbox"
                    ></vs-checkbox>
                    <p>Change Profile Details - (Password)</p>
                  </vs-row>
                  <!--Payment Info-->
                  <vs-row v-if="item[0] === 'update_payment_info'">
                    <vs-checkbox
                      v-model="updatePaymentInfoCheckbox"
                    ></vs-checkbox>
                    <p>Change Payment Information - (Password)</p>
                  </vs-row>
                  <!--Bank Account-->
                  <vs-row v-if="item[0] === 'update_bank_account'">
                    <vs-checkbox
                      v-model="updateBankAccountCheckbox"
                    ></vs-checkbox>
                    <p>Change Bank Account - (OTP)</p>
                  </vs-row>
                  <!--Manual Invoice-->
                  <vs-row v-if="item[0] === 'manual_invoice'">
                    <vs-checkbox v-model="manualInvoiceCheckbox"></vs-checkbox>
                    <p>Invoicing - (Password)</p>
                  </vs-row>
                  <!--Manual Payout-->
                  <vs-row v-if="item[0] === 'manual_payout'">
                    <vs-checkbox v-model="manualPayoutCheckbox"></vs-checkbox>
                    <p>Manual Payout - (OTP)</p>
                  </vs-row>
                </vs-col>
              </vs-row>
              <br />
              <br />
              <vs-button @click="change2faSettings">Save</vs-button>
              <p class="text-success m-2" v-if="changeSuccessful">
                2FA settings change is successful !
              </p>
              <p class="text-danger m-2" v-if="changeError">
                Error in changing the 2FA settings, please try again in a few
                moments
              </p>
            </div>
            <div v-else>Loading.....</div>
          </div>
          <div v-else>
            <p>
              You do not have permission to view or access this page for this
              merchant.
            </p>
          </div>
        </div>
        <div>
          <h2 class="mb-2" :style="{ paddingTop: '30px' }">
            Payout Approval Settings
          </h2>
          <div v-if="displayPayoutApprovalSettings">
            <p>Edit approvers for payout approval.</p>
            <br />
            <h5>Approvers:</h5>
            <table class="table-wrapper" v-if="approversList.length > 0">
              <template v-for="approver in approversList">
                <tr v-if="approver && approver.email" :key="approver.id">
                  <td>
                    <span class="approver-list select-none relative">
                      <x-circle-icon
                        @click="showDeleteApproverPrompt(approver)"
                        size="0.5x"
                        class="cross-icon"
                      ></x-circle-icon>
                      {{ approver.email }}</span
                    >
                  </td>
                </tr>
              </template>
            </table>
            <vs-prompt
              :active.sync="displayDeleteApprover"
              title="Delete Approver"
              accept-text="Confirm"
              cancel-text="Cancel"
              color="danger"
              @accept="deleteApprover(selectedApprover)"
            >
              <strong v-if="selectedApprover">{{
                selectedApprover.email
              }}</strong>
            </vs-prompt>
            <p>
              <span
                class="add-approver"
                :style="{ color: '#2774b1' }"
                @click="showAddApproverPrompt()"
                >Add Approvers</span
              >
            </p>
            <add-approver-prompt
              :active.sync="displayAddApprover"
              :createApprover="createApprover"
              :users="users"
            ></add-approver-prompt>
            <br />
            <div class="total-approvals">
              <span>
                <vs-input
                  :style="{ width: '50px', textAlign: 'center' }"
                  class="inputx"
                  :danger="isNaN(approvalTotal)"
                  danger-text="Please input a number."
                  v-model="approvalTotal"
                />
              </span>
              <p
                :style="{
                  position: 'relative',
                  bottom: '-7px',
                  marginLeft: '10px',
                  marginRight: '30px',
                }"
              >
                Approvals Required
              </p>

              <vs-button :style="{ height: '40px' }" @click="saveTotalApproval"
                >Save</vs-button
              >
            </div>
            <p class="approval-notes">
              Note:<br />
              1. Newly created accounts cannot have approval access for 24
              hours<br />
              2. Reduction in the number of approvals required will require 24
              hours before taking effect<br />
              3. Approvers will still maintain their permission access rights
              (Ex: if a user with "read" only permission is assigned as an
              approver, he will still remain his "read" only permission)<br />
              4. The approver and creator of a payout cannot be the same person.
              This means if an assigned approver created a payout, he will
              require another approver to approve the payout<br />
              5. Approvals can be done via the payout admin<br />
            </p>
          </div>
          <div v-else>
            <p>
              You do not have permission to view or access this page for this
              merchant.
            </p>
          </div>
        </div>
        <otp-prompt-for-authenticator-registration
          :active.sync="showOTPAuthenticatorPrompt"
          @verify="registerAndVerify"
          :qrCodeUrl="qrCodeUrl"
          :qrCodeError="qrCodeError"
          :authenticatorRegistrationCode="authenticatorRegistrationCode"
        >
        </otp-prompt-for-authenticator-registration>
      </template>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { XCircleIcon } from 'vue-feather-icons';
import AddApproverPrompt from '../../components/AddApproverPrompt.vue';

import QrcodeVue from 'qrcode.vue';
import OtpPromptForAuthenticatorRegistration from '../../components/OtpPromptForAuthenticatorRegistration.vue';

import { MFA_TYPE } from '../../constants';

export default {
  components: {
    XCircleIcon,
    AddApproverPrompt,
    QrcodeVue,
    OtpPromptForAuthenticatorRegistration,
  },
  data() {
    return {
      debugConsole: false,
      selectedMerchant: null,

      twoFactorAuthSettings: null,

      twoFactorAuthOptions: {
        dashboard_login: false,
        manual_invoice: false,
        manual_payout: false,
        update_bank_account: false,
        update_payment_info: false,
        update_profile_details: false,
      },

      dashboardLoginCheckbox: false,
      manualInvoiceCheckbox: false,
      manualPayoutCheckbox: false,
      updateBankAccountCheckbox: false,
      updatePaymentInfoCheckbox: false,
      updateProfileDetailsCheckbox: false,

      changeSuccessful: false,
      changeError: false,

      display2FASettings: false,
      displayPayoutApprovalSettings: false,
      users: [],
      displayAddApprover: false,
      displayDeleteApprover: false,
      approvalTotal: 0,
      selectedApprover: '',

      showOTPAuthenticatorPrompt: false,
      qrCodeUrl: '',
      qrCodeError: false,
      authenticatorRegistrationCode: '',
    };
  },
  computed: {
    ...mapGetters([
      'activeMerchantGetter',
      'merchantsGetter',
      'currentActiveEntityAdminGetter',
      'approversGetter',
      'listOfEntityAdminGetter',
      'approvalGetter',
      'activeUserGetter',
      'entityAdmin2FATypeGetter',
    ]),
    mfaType() {
      return MFA_TYPE;
    },
    merchantsList() {
      return this.merchantsGetter.length > 0 ? this.merchantsGetter : [];
    },

    usersMap() {
      return this.users.reduce(
        (usersMap, user) => usersMap.set(user.id, user.email),
        new Map()
      );
    },

    approversList() {
      // return approvers list with email
      if (this.debugConsole) {
        console.log('approversGetter', this.approversGetter);
      }
      return this.approversGetter.map((approver) => ({
        ...approver,
        email: this.usersMap.get(approver.entity_admin_id),
      }));
    },
  },
  watch: {
    entityAdmin2FATypeGetter: function(newVal, oldVal) {
      if (this.debugConsole) {
        console.log('EntityAdmin2FATypeGetter newVal', newVal);
        console.log('EntityAdmin2FATypeGetter oldVal', oldVal);
      }
    },
    dashboardLoginCheckbox: function(newVal, oldVal) {
      if (this.debugConsole) {
        console.log('DashboardLoginCheckbox newval', newVal);
        console.log('DashboardLoginCheckbox oldVal', oldVal);
      }
    },

    activeMerchantGetter(newValue, oldValue) {
      if (this.debugConsole) {
        console.debug(
          'watch: activeMerchantGetter: update detected',
          newValue,
          oldValue
        );
      }
      this.selectedMerchant = newValue;
      this.check2faSettingsHandler(newValue.id);
      this.checkPayoutApprovalSettingsHandler(newValue.id);
    },
  },
  mounted() {
    //check for selected Merchant
    this.selectedMerchant = this.activeMerchantGetter;

    this.setValuefor2faSettings(this.selectedMerchant);

    //check the permission of the user in the default selected merchant
    let currentActiveMerchantId =
      this.selectedMerchant && this.selectedMerchant.id;
    if (this.debugConsole) {
      console.log('Current Active Merchant Id', currentActiveMerchantId);
    }

    this.check2faSettingsHandler(currentActiveMerchantId);

    this.checkPayoutApprovalSettingsHandler(currentActiveMerchantId);
  },

  methods: {
    ...mapActions([
      'save2faSettings',
      'getEntityAdminList',
      'apiGetApprovers',
      'apiAddApprovers',
      'apiDeleteApprovers',
      'apiCreateApproval',
      'apiGetApproval',
    ]),

    registerAuthenticatorPrompt() {
      this.showOTPAuthenticatorPrompt = true;
      this.generateQRCode();
    },

    async registerAndVerify(otp) {
      this.showOTPAuthenticatorPrompt = true;
      this.registerAndVerifyOTP(otp)
        .then((res) => {
          this.showOTPAuthenticatorPrompt = false;
          // set entity admin 2FA type
          this.$store.commit('UPDATE_ENTITY_ADMIN_2FA_TYPE', res.data.mfa_type);
        })
        .catch(() => {
          this.showOTPAuthenticatorPrompt = true;
          if (this.showOTPAuthenticatorPrompt) {
            this.$vs.notify({
              title: 'Error',
              text: `Failed to verify OTP. Please insert the correct OTP`,
              color: 'danger',
            });
          }
        });
    },

    async generateQRCode() {
      // generate QR code
      await this.qrCodeForAuthenticatorRegistration()
        .then((res) => {
          this.qrCodeUrl = res.data.url;
          // extract code from the url;
          this.authenticatorRegistrationCode = this.extractAuthenticatorCode(
            this.qrCodeUrl
          );
          this.qrCodeError = false;
        })
        .catch((err) => {
          console.error('Err in getting QR code', err);
          this.qrCodeError = true;
        });
    },

    extractAuthenticatorCode(url) {
      const values = url.split('&');

      for (const value of values) {
        const keyValue = value.split('=');
        if (keyValue[0] === 'secret') {
          return keyValue[1];
        }
      }
      return null;
    },

    copyAuthenticatorCode() {
      this.copyToClipboard(this.authenticatorRegistrationCode);
    },

    check2faSettingsHandler(selectedMerchantId) {
      this.display2FASettings = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        selectedMerchantId,
        '2fa_settings',
        'W'
      );
      if (this.debugConsole) {
        console.log('Content Is Displayed', this.display2FASettings);
      }
    },

    checkPayoutApprovalSettingsHandler(selectedMerchantId) {
      this.displayPayoutApprovalSettings = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        selectedMerchantId,
        '2fa_settings',
        'W'
      );
      if (this.debugConsole) {
        console.log(
          'DisplayPayoutApprovalSettings',
          this.displayPayoutApprovalSettings
        );
      }

      if (this.displayPayoutApprovalSettings) {
        this.getPossibleApproversList();
        this.apiGetApprovers(selectedMerchantId);
        this.apiGetApproval(selectedMerchantId).then(() => {
          this.approvalTotal = this.approvalGetter ? this.approvalGetter : 0;
        });
      }
    },

    setValuefor2faSettings(selectedMerchant) {
      // check the merchant's 2fa settings
      this.twoFactorAuthSettings = selectedMerchant.two_factor_auth;

      for (const [key, value] of Object.entries(this.twoFactorAuthSettings)) {
        if (key === 'dashboard_login') {
          this.dashboardLoginCheckbox = value;
        }
        if (key === 'manual_invoice') {
          this.manualInvoiceCheckbox = value;
        }
        if (key === 'manual_payout') {
          this.manualPayoutCheckbox = value;
        }
        if (key === 'update_bank_account') {
          this.updateBankAccountCheckbox = value;
        }
        if (key === 'update_payment_info') {
          this.updatePaymentInfoCheckbox = value;
        }
        if (key === 'update_profile_details') {
          this.updateProfileDetailsCheckbox = value;
        }
      }
    },

    getPossibleApproversList() {
      this.getEntityAdminList().then(() => {
        if (
          this.currentActiveEntityAdminGetter &&
          this.currentActiveEntityAdminGetter.email.includes('@triple-a.io')
        ) {
          this.users = [...this.listOfEntityAdminGetter].filter(
            (item) => this.selectedMerchant.id in item.merchants
          );
        }
        // need to filter to not include Triple-A team member, as some of Triple-A team member is using the alternative email (adding '+' before triple-a.io)
        else {
          this.users = [...this.listOfEntityAdminGetter].filter(
            (item) =>
              !item.email.includes('@triple-a.io') &&
              this.selectedMerchant.id in item.merchants
          );
        }
      });
    },

    change2faSettings() {
      let data = {};
      data.dashboard_login = this.dashboardLoginCheckbox;
      data.manual_invoice = this.manualInvoiceCheckbox;
      data.manual_payout = this.manualPayoutCheckbox;
      data.update_bank_account = this.updateBankAccountCheckbox;
      data.update_payment_info = this.updatePaymentInfoCheckbox;
      data.update_profile_details = this.updateProfileDetailsCheckbox;

      let payload = {};
      payload.merchantKey = this.selectedMerchant.merchant_key;
      payload.data = data;

      if (this.debugConsole) console.log('Payload', payload);

      this.save2faSettings(payload)
        .then((res) => {
          this.changeSuccessful = true;
          this.changeError = false;
          if (this.debugConsole) console.log('Change 2fa Settings Result', res);

          //call the merchants API for the 2fa changes to be updated when page is refreshed
          this.apiGetMerchants();

          //to get the component obj so can access from inside the setTimeout callback function
          let thisObj = this;
          setTimeout(function() {
            thisObj.changeSuccessful = false;
          }, 3000);
        })
        .catch((err) => {
          console.log('Error in changing 2fa settings', err);
          this.changeSuccessful = false;
          this.changeError = true;

          //to get the component obj so can access from inside the setTimeout callback function
          let thisObj = this;
          setTimeout(function() {
            thisObj.changeError = false;
          }, 3000);
        });
    },

    onChangeMerchant(selectedMerchant) {
      this.selectedMerchant = this.merchantsGetter.find(
        (item) => item.merchant_key === selectedMerchant.merchant_key
      );

      this.setValuefor2faSettings(this.selectedMerchant);

      const currentActiveMerchantId =
        this.selectedMerchant && this.selectedMerchant.id;
      if (this.debugConsole) {
        console.log('Current Active Merchant Id', currentActiveMerchantId);
      }
      this.check2faSettingsHandler(currentActiveMerchantId);
      this.checkPayoutApprovalSettingsHandler(currentActiveMerchantId);
    },

    showAddApproverPrompt() {
      this.displayAddApprover = true;
    },

    showDeleteApproverPrompt(approverId) {
      this.displayDeleteApprover = true;
      this.selectedApprover = approverId;
    },

    createApprover(entityAdminIds) {
      const payload = entityAdminIds.map((entityAdminId) => ({
        merchant_id: this.activeMerchantGetter.id,
        entity_admin_id: entityAdminId,
      }));
      this.apiAddApprovers(payload)
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Payout approver has been added successfully',
            color: 'success',
          });
          this.apiGetApprovers(this.activeMerchantGetter.id);
        })
        .catch((err) => {
          err = err.response.data;
          let text = '';
          let account =
            (err.entity_admin_id && this.usersMap.get(err.entity_admin_id)) ||
            '';
          if (err.message && err.message.includes('new_account')) {
            text = `It has been less than 24 hours since the account was created. <br/><b>${account}</b> `;
          } else if (err.message && err.message.includes('no_link')) {
            text = `Account is not linked to the merchant. <br/><b>${account}</b>`;
          } else if (err.message && err.message.includes('no_permission')) {
            text = 'You do no have permission. ';
          } else {
            text = 'Error occurred while trying to add payout approver';
          }
          this.$vs.notify({
            title: 'Error',
            text: text,
            color: 'danger',
          });
          if (this.debugConsole) console.log(err);
        });
    },

    deleteApprover(approver) {
      if (!approver) {
        return;
      }
      this.apiDeleteApprovers(approver.id)
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Payout approver has been deleted successfully',
            color: 'success',
          });
          this.apiGetApprovers(this.activeMerchantGetter.id);
        })
        .catch((err) => {
          err = err.response.data;
          let text = '';
          if (err.message && err.message.includes('no_permission')) {
            text = 'You do no have permission.';
          } else {
            text = 'Error occurred while trying to delete payout approver';
          }
          this.$vs.notify({
            title: 'Error',
            text: text,
            color: 'danger',
          });
          if (this.debugConsole) console.log(err);
        });
    },

    saveTotalApproval() {
      const payload = {
        merchant_id: this.activeMerchantGetter.id,
        approval_total: this.approvalTotal,
      };
      this.apiCreateApproval(payload)
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'The changes have been applied successfully.',
            color: 'success',
          });
        })
        .catch((err) => {
          err = err.response.data;
          let text = '';
          if (err.message && err.message.includes('is_exists')) {
            text = 'Nothing has been changed.';
          } else if (err.message && err.message.includes('no_permission')) {
            text = 'You are not permissioned to make this change.';
          } else {
            text = 'Error occurred while trying to apply the changes. ';
          }
          this.$vs.notify({
            title: 'Error',
            text: text,
            color: 'danger',
          });
          if (this.debugConsole) console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
main {
  position: relative;
}

.account-selection {
  height: 38px;
  border-radius: 5px;
  margin: 2px 0;
  border: 1px solid #505050;
  padding: 0.5rem;
  background-color: white !important;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-size: 1rem;
}

.account-selection-manage-users {
  height: 25px;
  border-radius: 5px;
  border: 0.5px solid #cdcdcd;
  padding: 3px;
  background: #ffffff;
  color: dimgrey;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-size: 14px;
}

.tel-selection-manage-users {
  height: 38px;
  border-radius: 5px;
  margin: 2px 0;
  border: 1px solid #cdcdcd;
  padding: 0.5rem;
  background-color: white !important;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-size: 1rem;
}

//to make the dialog width wider
.con-vs-dialog .vs-dialog {
  transition: all 0.2s;
  z-index: 100;
  width: calc(100% - 20px);
  margin: 10px;
  max-width: 500px;
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  -webkit-animation: rebound 0.3s;
  animation: rebound 0.3s;
}

//to make the dropdown list in front of the "Assign to merchants" table
.vti__dropdown-list {
  z-index: 999999 !important;
  padding: 0;
  margin: 0;
  text-align: left;
  list-style: none;
  max-height: 200px;
  overflow-y: scroll;
  position: absolute;
  left: -1px;
  background-color: #fff;
  border: 1px solid #ccc;
  width: 390px;
}

#withdrawal-currency > span {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.con-expand-users {
  .con-btns-user {
    display: flex;
    padding: 10px;
    padding-bottom: 0px;
    align-items: center;
    justify-content: space-between;
    .con-userx {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }
  .list-icon {
    i {
      font-size: 0.9rem !important;
    }
  }
}

.input-error-style {
  border: 1px solid #ff0000;
}

.text-small {
  font-size: small;
}

.text-large {
  font-size: large;
}

.fw-500 {
  font-weight: 500;
}

.text-underline {
  text-decoration: underline;
}

.approval {
  padding-top: '30px';
  padding-bottom: '10px';
}

.table-wrapper {
  padding: var(--metric-box-spacing);
  padding-top: 15px;
  box-shadow: var(--generic-shadow);
  font-weight: 500;
  text-align: left;
  margin-bottom: 30px;
  table-layout: fixed;
  margin-right: 10%;
  tr {
    height: 40px;
  }
}

.cross-icon {
  &:hover {
    color: red;
    cursor: pointer;
  }
  position: relative;
  bottom: -2px;
  height: 14px;
}

.add-approver {
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}

.total-approvals {
  display: flex;
  flex-direction: row;
}

input {
  text-align: center;
}

.approval-notes {
  margin-top: 30px;
  font-size: 10.5px;
  color: #a4a4a4;
  font-weight: 600;
}
</style>
